module.exports = __webpack_public_path__ + "img/img9.80d3639e.svg";